import { Component } from 'react';
import { Box, Chip, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

import Info from '../bio/Info';
import CV from '../bio/CV';

export default class MyCV extends Component {
  componentDidMount() {
    document.title = 'LeKinaSá | CV';
  }
  
  render() {
    let label = <FontAwesomeIcon className='icon' icon={faLink} size='xl' />;
    return (
      <Grid container className='fill-screen' sx={{ width: '100%' }} >
        <Grid className='center-flex grid-item' key='1' size={{ xs: 12, lg: 8 }} >
          <Box className='cv'>
            <Box className='center-block'>
                <CV />
            </Box>
          </Box>
        </Grid>
        <Chip className='transparent contact cv-link' label={label}
            component='a' href='https://github.com/LeKinaSa/cv/blob/main/CV_Clara_Martins.pdf' clickable />
        <Grid className='info grid-item' key='2' size={{ xs: 12, lg: 4 }} >
          <Info />
        </Grid>
      </Grid>
    );
  }
}
